export default {
  SET_AUTH: 'SET_AUTH',
  GET_AUTH: 'GET_AUTH',
  DOWNLOAD: 'DOWNLOAD',
};



// WEBPACK FOOTER //
// ./src/store/types.js